import { useContext } from 'react'

import { SessionContext, type SessionContextValue } from './sessionContext'

export function useSession(): SessionContextValue {
  const value = useContext(SessionContext)
  if (!value) {
    throw new Error('useSession dipakai di luar SessionProvider')
  }
  return value
}
